import { ModalBody } from "./ModalBody";
import { ModalContainer } from "./ModalContainer";
import { ModalContent } from "./ModalContent";

export default {
  ModalContent,
  ModalContainer,
  ModalBody,
};
